<template>
  <div class="flex flex-col items-center justify-center h-full px-4">
    <img
      class="w-60 mb-6"
      src="~dashboard/assets/images/no-conversation-selected.png"
      alt=""
    />
    <h3
      class="m-0 max-w-[26.25rem] text-base leading-6 font-semibold text-center text-[#1F2937] dark:text-slate-100"
    >
      {{ message }}
    </h3>
    <p
      v-if="description"
      class="m-0 mt-1 max-w-[26.25rem] text-base leading-6 text-center text-[#4B5563] dark:text-slate-300"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>
